import React from 'react';
import {Image, View} from 'react-native';
import {makeStyles} from '@rneui/themed';

import id25 from '../../images/brand/id25.png';
import Text from '../themed/Text';

function Over18() {
  const styles = useStyles();
  return (
    <View style={[styles.containerStyle]}>
      <Image style={styles.imageStyle} source={id25} resizeMode="contain" />
      <Text style={styles.text}>
        Must be over 18+. Have your photo ID handy when collecting your order.
      </Text>
    </View>
  );
}

const useStyles = makeStyles(theme => {
  return {
    containerStyle: {
      backgroundColor: theme.colors.grey5,
      flexDirection: 'row',
      padding: 20,
      marginHorizontal: -20,
      gap: 20,
      alignItems: 'center',
    },
    text: {
      color: theme.colors.grey2,
      flex: 1,
    },
    imageStyle: {
      width: 36,
      height: 36,
    },
  };
});

export default Over18;
